"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsFileAccessibleAnonymously = getIsFileAccessibleAnonymously;
exports.getIsFileSubmittedThroughForms = getIsFileSubmittedThroughForms;
exports.getIsFileExternal = getIsFileExternal;
exports.getIsFilePrivate = getIsFilePrivate;
exports.getIsFilePublic = getIsFilePublic;
exports.getVisibilityOptionForFile = exports.getFileAccess = exports.getIsFileIndexable = void 0;

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _Constants = require("../Constants");

var _InternalFileManagerFileAccess = require("../enums/InternalFileManagerFileAccess");

var _FileVisibilityOptions = require("../enums/FileVisibilityOptions");

var FORM_UPLOADS_FOLDER_NAME = 'form-uploads';

function getIsFileAccessibleAnonymously(file) {
  var isFilePubliclyAccessible = file.getIn(_Constants.PathToFileAccessibility);
  return isFilePubliclyAccessible !== null && isFilePubliclyAccessible !== undefined ? Boolean(isFilePubliclyAccessible) : true;
}

function getIsFileSubmittedThroughForms(file) {
  var fileCloudKey = file.get('cloud_key') || '';
  return fileCloudKey.indexOf("hubfs/" + _PortalIdParser.default.get() + "/" + FORM_UPLOADS_FOLDER_NAME) > -1;
}

function getIsFileExternal(file) {
  return !getIsFileAccessibleAnonymously(file) && getIsFileSubmittedThroughForms(file);
}

function getIsFilePrivate(file) {
  return !getIsFileAccessibleAnonymously(file) && !getIsFileSubmittedThroughForms(file);
}

function getIsFilePublic(file) {
  return getIsFileAccessibleAnonymously(file);
}

var getIsFileIndexable = function getIsFileIndexable(file) {
  return file.get('is_indexable');
};

exports.getIsFileIndexable = getIsFileIndexable;

var getFileAccess = function getFileAccess(file) {
  if (getIsFilePrivate(file)) {
    return _InternalFileManagerFileAccess.VISIBLE_IN_APP_PRIVATE_NOT_INDEXABLE;
  }

  return getIsFileIndexable(file) ? _InternalFileManagerFileAccess.VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE : _InternalFileManagerFileAccess.VISIBLE_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE;
};

exports.getFileAccess = getFileAccess;

var getVisibilityOptionForFile = function getVisibilityOptionForFile(file) {
  if (file.getIn(_Constants.PathToFileAccessibility) && file.get('is_indexable')) {
    return _FileVisibilityOptions.FileVisibilityOptionNames.VISIBLE_TO_ALL;
  }

  if (file.getIn(_Constants.PathToFileAccessibility) && !file.get('is_indexable')) {
    return _FileVisibilityOptions.FileVisibilityOptionNames.VISIBLE_TO_USERS_HIDDEN_FROM_SEARCH_ENGINES;
  }

  return _FileVisibilityOptions.FileVisibilityOptionNames.HIDDEN_FROM_ALL;
};

exports.getVisibilityOptionForFile = getVisibilityOptionForFile;